import { Component, OnInit } from '@angular/core';
import { AddSupervisorService } from '../../service/main/add-supervisor.service';
import { CryptoHashService } from '../../service/common/crypto-hash.service';
import { ToastrService } from '../../service/common/toastr.service';
import { Router } from '@angular/router';
import { PortalOperator } from '../../entity';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../service';

@Component({
    selector: 'app-add-supervisor',
    templateUrl: './supervisor-add.component.html'
})
export class SupervisorAddComponent implements OnInit {
    supervisor: PortalOperator = new PortalOperator();
    user: any;

    constructor(
        private addSupervisorService: AddSupervisorService,
        private cryptoHash: CryptoHashService,
        private toastr: ToastrService,
        private router: Router,
        private authService: AuthService
    ) { }

    ngOnInit() {
        this.user = this.authService.loadUserData();
        this.setSupervisorCompany();
    }

    registerSupervisor(form: NgForm) {

        const dto: PortalOperator = {
            ...this.supervisor,
            Password: this.cryptoHash.sha512(this.supervisor.Password, 512)
        };

        this.addSupervisorService.addSupervisor(dto).subscribe(data => {
            form.reset();
            this.toastr.success('Supervisor successfully added.');
            this.router.navigate(['supervisors']);
        }, err => {
            this.toastr.error('A error has occurred while adding the supervisor.');
        });
    }

    setSupervisorCompany() {
        if (this.user.company != null) {
            this.supervisor.CompanyID = this.user.company;
        } else if (this.user.publicInstitution != null) {
            this.supervisor.PublicInstitutionID = this.user.publicInstitution;
        }
    }

    cancel() {
        this.router.navigate(['supervisors']);
    }
}

